import { ReactNode } from "react";
import { Info } from "lucide-react";

const InfoHint = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={`flex items-start gap-2 text-xs text-gray-secondary bg-blue-50 px-3 py-2 rounded-lg ${className || ""}`}
    >
      <Info className="w-4 h-4 text-blue-500 shrink-0 mt-0.5" />
      <span>{children}</span>
    </div>
  );
};

export default InfoHint;
